<template>
  <div>
    <div class="nav">
      <div class="nav-item" :class="{
        'nav-act': tag_id == null
      }" @click="filterType(null)">全部</div>
      <div class="nav-item" :class="{
        'nav-act': tag_id == item.id
      }" v-for="(item, key) in tagList" :key="key" @click="filterType(item)">
        {{ item.name }}
      </div>
    </div>

    <div class="list">
      <div v-for="(item, key) in questionList" class="question" :key="key" @click="getQuestion(item)">
        <div class="title">
          {{ (page.pageNum * page.pageSize - page.pageSize + key + 1) }} 、<span>{{ item.title }}</span>
        </div>
        <div class="tag-item">
          <span v-for="(val, k) in item.tags" :key="k">{{ val.name }}
            <span v-if="item.tags.length != k + 1">、</span>

          </span>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination :hide-on-single-page="true" :page-size="page.pageSize" :current-page="page.pageNum"
        :total="page.total" class="page-box" layout="prev, pager, next" @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      tagList: [],
      questionList: [],
      page: {
        pageSize: 12,
        pageNum: 1,
        total: 0,
      },
      tag_id: null
    };
  },
  computed: {
  },
  created() {
    this.getType()
    this.getList()
  },
  methods: {
    filterType(item) {
      this.page.pageNum = 1
      if (item) {
        this.tag_id = item.id
      } else {
        this.tag_id = null
      }
      this.getList()
    },
    getType() {
      this.$fecth.post('chats/get_chat_tag_list', []).then((res) => {
        this.tagList = res.lists
      })
    },
    getList() {
      let data = {
        tag_id: this.tag_id,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      }
      this.$fecth.post('chats/get_chat_question_list', data).then((res) => {
        this.questionList = res.lists
        this.page.total = res.total
      })
    },
    pageChange(page) {
      this.page.pageNum = page
      this.getList()
    },
    getQuestion(e) {
      let data = {
        title: e.title,
        report: e,
        type: 1
      }
      this.$emit('getChat', data)
    },
  },
};
</script>

<style scoped lang='less'>
.nav {
  display: flex;
  gap: 20px;
  padding-left: 30px;
  padding-bottom: 20px;


  .nav-item {
    color: #FF6720;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 30px;
  }

  .nav-item:hover {
    background: #FF6720;
    color: white;
  }

  .nav-act {
    background: #FF6720;
    color: white;
  }
}

.question {
  font-size: 20px;
  line-height: 50px;
  padding-left: 15px;
  border-radius: 13px;
  position: relative;
}

.question:hover {
  background: #F5F5F5;
}

.title {
  width: 1000px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag-item {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  padding: 0 5px;
  color: #bdbdbd;

}

.pagination {
  width: 1200px;
  position: fixed;
  bottom: 0px;
  padding: 25px 0;

  .page-box {
    text-align: center;
  }
}
</style>
